import { ArrowRightGlobalNavigation } from 'src/components/icons/ArrowRightGlobalNavigation'
import type { ParentAndLinkItemProps } from '../../../global-navigation'
import { hasNextLevel } from '../../../utils'

export const Basic = ({ item }: ParentAndLinkItemProps) => {
  return (
    <div className="text-sm font-semibold tracking-[0.035px] text-[#535353] flex flex-row justify-between items-center">
      <span className="block">{item.label}</span>
      {hasNextLevel(item) && (
        <span className="block w-6 h-6">
          <ArrowRightGlobalNavigation />
        </span>
      )}
    </div>
  )
}
